// do not change values of the constants (video object proxy to player widget)
import { RemoveRedEyeRounded, ShareRounded, ThumbUpAltRounded, ThumbUpOffAlt } from '@mui/icons-material';

import { LIKE_KEY, SHARE_KEY, VIEW_KEY } from '@/modules/common/constants/configuration';

export const LIKES = 'LIKE' as const;
export const SHARES = 'SHARE' as const;
export const VIEWS = 'VIEW' as const;

export const ALL_SOCIAL_ENGAGEMENT_TYPES = [VIEWS, LIKES, SHARES] as const;

// important: it is mapping between config.json and data in video
export const VIDEO_ENGAGEMENT_SOCIAL_TYPE = {
  VIEWS,
  LIKES,
  SHARES,
} as const;

export const VIDEO_SOCIAL_MAP = {
  [VIEWS]: {
    icon: RemoveRedEyeRounded,
    configKey: VIEW_KEY,
  },
  [LIKES]: {
    icon: ThumbUpAltRounded,
    iconInactive: ThumbUpOffAlt,
    configKey: LIKE_KEY,
  },
  [SHARES]: {
    icon: ShareRounded,
    configKey: SHARE_KEY,
  },
} as const;
